import _ from 'lodash'
import {observable, computed, reaction} from 'mobx'

export default class StoreBase {
  constructor() {
  }
}
